export const SESSION_CONTENTS = "SGREP_SESSION_CONTENTS";
